import styled from 'styled-components'
import { cardSurface } from '@components/Card'
import { darkOrange, black, textMuted, white, warmTint } from '@/theme/colors'
import { shadows, radii, media, motion } from '@/theme/tokens'
import { text } from '@/theme/typography'




export const MembersGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
	gap: 18px;

	${media.phone} {
		grid-template-columns: repeat(2, 1fr);
		gap: 12px;
	}
`

export const MemberCard = styled.div`
	background: ${white};
	border-radius: ${radii.card};
	padding: 24px 12px;
	box-shadow: ${shadows.card};
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
`


export const MemberCardName = styled.div`
	${text.label}
	color: ${black};
	text-align: center;
`

/**
 * The empty seat at the end of the grid. Mirrors a member card's geometry but
 * stays deliberately flat (no shadow) and warm-tinted, so it reads as an
 * invitation rather than a person.
 */
export const InviteGhostCard = styled.button`
	background: ${warmTint};
	border: none;
	border-radius: ${radii.card};
	padding: 24px 12px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 12px;
	cursor: pointer;
	transition:
		filter ${motion.base},
		transform ${motion.fast};

	&:hover {
		filter: brightness(0.97);
	}

	&:active {
		transform: scale(0.98);
	}

	&:focus-visible {
		outline: 2px solid ${darkOrange};
		outline-offset: 2px;
	}
`


export const InviteGhostLabel = styled.span`
	${text.label}
	color: ${darkOrange};
	text-align: center;
`


/** A member card's owner-only Remove: quiet, under the name. */
export const MemberCardActions = styled.div`
	display: flex;
	justify-content: center;
`

/** The owner's pending Join requests, above the members. */
export const RequestsSection = styled.section`
	margin-bottom: 28px;
`

/** A section's heading row on the owner's page — Requests, Members — 16px above what it heads. */
export const SectionHead = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 16px;
`

export const RequestList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`

/** A Join request row: the requester, when they asked, Deny and Approve. */
export const RequestRow = styled.div`
	${cardSurface}
	padding: 14px 16px;
	display: flex;
	align-items: center;
	gap: 12px;

	${media.phone} {
		flex-wrap: wrap;
	}
`

export const RequestText = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
	flex: 1;
	min-width: 0;
`

/** A list row's name, as the design system sets list rows. */
export const RequestName = styled.span`
	${text.labelSm}
	color: ${black};
`

export const RequestMeta = styled.span`
	${text.bodySm}
	color: ${textMuted};
`

export const RequestActions = styled.div`
	display: flex;
	gap: 8px;

	${media.phone} {
		width: 100%;
		justify-content: flex-end;
	}
`
